import { Vue, Component, Prop } from 'vue-property-decorator'
import { store } from '@/store';
import moment from 'moment'
import { IMessage } from '@/galaxy-cruise/api_interface';
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert';
import ContentWindow from './ContentWindow/index.vue'
import { reloadMessages } from '@/galaxy-cruise/utils';

@Component
export default class extends Vue {
  @Prop()
  initialLastMessageCheck!: string

  lastMessageCheck = this.initialLastMessageCheck

  isNewMessage(m: IMessage) {
    return moment(m.published_at).toISOString() > this.lastMessageCheck
  }

  get messages() {
    return store.galaxyCruise.messages
  }

  formatDate(s: string) {
    return moment(s).format('YYYY/M/D HH:mm')
  }

  async showMessage(message: IMessage) {
    await asyncAlert({ component: ContentWindow, props: { message } })
  }

  async makeAllAsRead() {
    const { now } = await reloadMessages(true)
    this.lastMessageCheck = moment(now).toISOString()
  }

  get allRead() {
    return this.messages.every((m) => moment(m.published_at).toISOString() <= this.lastMessageCheck)
  }
}
